import { render, staticRenderFns } from "./parametriProdotti.vue?vue&type=template&id=66bb77fc&"
import script from "./parametriProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./parametriProdotti.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports